import React, { createContext, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import { routes, userRoutes } from "./routes";
import "../src/assets/scss/global.scss";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme/index";
import messagesEn from "../src/helpers/en.json";
import { fetchFromStorage } from "./helpers/context/Storage";
import { setSentryUser, setSentryTags, sendSentrySmokeTest } from "./helpers/context/sentry";
import { sendMixpanelSmokeTest } from "./helpers/context/mixpanel";
import SentryRouteTracker from "./helpers/context/SentryRouteTracker";

const Context = createContext();

const App = () => {
  const redux_auth = useSelector((state) => state?.ActionReducer?.authdata);
  const auth = redux_auth ? redux_auth : fetchFromStorage("authdata");

  let routeData = auth ? userRoutes : routes;
  const routing = useRoutes(routeData);

  const messages = { ...messagesEn };

  useEffect(() => {
    setSentryUser(auth?.data || null);
    setSentryTags({
      has_session: auth ? "true" : "false",
    });
  }, [auth]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("sentry_test") === "1") {
      sendSentrySmokeTest().then((result) => {
        // eslint-disable-next-line no-console
        console.info("[Sentry] Smoke test result:", result);
      });
    }
    if (params.get("mixpanel_test") === "1") {
      const result = sendMixpanelSmokeTest();
      // eslint-disable-next-line no-console
      console.info("[Mixpanel] Smoke test result:", result);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Context.Provider value={{ messages }}>
        <SentryRouteTracker />
        {routing}
      </Context.Provider>
    </ThemeProvider>
  );
};

export default App;
export { Context as IntlContext };
